export const environment = {
  appVersion: 'Anna - version 2.0.0',
  production: true,
  apiUrl: 'https://anna-new-api.baobif.com/',
  fontUrl: 'https://anna-new.baobif.com/',
  companyInfo:{
    companyName: 'Công ty TNHH Bao bì Anna'
  },
  pdfConfig:{
    dorA4Full: "SdDorPdfA4FullM1"
  },
  firebase: {
    projectId: 'idstestbaobifcom',
    appId: '1:777769681587:web:acee32493317700f3ce6c6',
    databaseURL: 'https://idstestbaobifcom.firebaseio.com',
    storageBucket: 'idstestbaobifcom.appspot.com',
    apiKey: 'AIzaSyBrYKQpU8XxBYDl-NkJ6TCIltW6uAkj16c',
    authDomain: 'idstestbaobifcom.firebaseapp.com',
    messagingSenderId: '777769681587',
    measurementId: 'G-4YRB2WY7KP',
  },
};
